import { PUBLIC_RPC } from "@/lib/chains";

const EVM_ADDRESS_RE = /^0x[a-fA-F0-9]{40}$/;

export function isEvmAddress(value: string): boolean {
  return EVM_ADDRESS_RE.test(value);
}

/**
 * Makes a raw `eth_call` to a contract and returns the hex result.
 * Validates the response is a standard 32-byte ABI-encoded word (66 chars).
 * Used by ERC-4626 hooks to avoid bundling viem in the ActionNode chunk.
 */
export async function ethCallRaw(address: string, selector: string, chainId: number): Promise<string> {
  const rpcUrl = PUBLIC_RPC[chainId];
  if (!rpcUrl) throw new Error(`No RPC for chain ${chainId}`);

  const res = await fetch(rpcUrl, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      jsonrpc: "2.0",
      id: 1,
      method: "eth_call",
      params: [{ to: address, data: selector }, "latest"],
    }),
  });

  if (!res.ok) {
    throw new Error(`RPC request failed: ${res.status}`);
  }

  const json = await res.json();
  if (json.error) {
    throw new Error(`RPC error: ${json.error.message || JSON.stringify(json.error)}`);
  }
  if (!json.result || json.result === "0x") {
    throw new Error(`Empty result calling ${selector} on ${address}`);
  }

  const raw = json.result as string;
  if (raw.length !== 66) {
    throw new Error(`Unexpected return length: ${raw.length}`);
  }

  return raw;
}
